import React from 'react';
import useStyles from './styles';
import { TagModalForm } from './form';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Icon, SimpleModal } from '@livable/saas-react-components';
export const TagModal = observer(_ref => {
  let tags = _ref.tags,
    companyId = _ref.companyId,
    trigger = _ref.trigger,
    triggerButton = _ref.triggerButton,
    isOpen = _ref.isOpen,
    handleClose = _ref.handleClose;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const defaultTrigger = /*#__PURE__*/React.createElement("div", {
    className: classes.trigger
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus-circle"
  }));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    title: t('admin_page.add_tags'),
    trigger: triggerButton !== undefined ? triggerButton : defaultTrigger,
    noFooter: true,
    isOpen: isOpen ? isOpen : undefined,
    handleClose: handleClose ? handleClose : undefined
  }, /*#__PURE__*/React.createElement(TagModalForm, {
    companyId: companyId,
    tags: tags,
    trigger: trigger
  }));
});